import { App } from "vue";

// 拖拽滚动指令
const dragScroll = {
  mounted(el: HTMLElement) {
    el.style.cursor = 'grab';
    el.style.userSelect = 'none';

    el.addEventListener('mousedown', (e: MouseEvent) => {
      el.style.cursor = 'grabbing';
      const startX = e.pageX - el.offsetLeft;
      const scrollLeft = el.scrollLeft;

      const mouseMoveHandler = (e: MouseEvent) => {
        e.preventDefault();
        const x = e.pageX - el.offsetLeft;
        const walk = (x - startX) * 2;
        el.scrollLeft = scrollLeft - walk;
      };

      const mouseUpHandler = () => {
        el.style.cursor = 'grab';
        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);
      };

      document.addEventListener('mousemove', mouseMoveHandler);
      document.addEventListener('mouseup', mouseUpHandler);
    });
  }
};

export default {
  install: (app: App) => {
    app.directive('drag-scroll', dragScroll);
  },
};
